<template>
  <div class="content">
    <img :src="detail" alt="" />
  </div>
</template>

<script>
import { getShareActivity } from "@/api/public";
export default {
  data() {
    return {
      detail: "",
    };
  },
  mounted() {
    this.detail = this.$route.query.url;
    console.log(this.$route.query);
    console.log(this.detail);
  },
  methods: {
    getShareActivity() {
      getShareActivity().then((res) => {
        this.detail = res.data.share_poster_details;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.content {
  width: 100%;
}
.content img {
  width: 100%;
}
</style>
